import { InlineStack, Tabs } from '@shopify/polaris';
import React, { memo, useCallback, useEffect, useMemo } from 'react'
import { useTour } from '../../../Other/tour';
import { DIProps } from '../../../../Core';
import { CustomTabs } from '../../../CustomTab/CustomTab';
import { useTranslation } from 'react-i18next';

interface Props extends DIProps { // interface for props
    selected: number,
    setSelected: (value: number) => void
    allFiltersNew: any
    setallFilters: (data: any) => void
    loading: (data: boolean) => void
}

function TabsComponent(props: Props) {
    const { t } = useTranslation();
    const { setCurrentStep, setTourLoading, isOpen } = useTour()
    const { selected, setSelected, setallFilters, allFiltersNew } = props //destructuring the Props

    const tabs: any = [
        {
            id: 'all',
            content: <span>{t('All')}</span>
        },
        {
            id: 'not_listed',
            content: <div className='custom-notlisted-badge'>
                <span>{t("Not Listed")}</span>
            </div>
        },
        // {
        //     id: 'Ready-To-Upload',
        //     content: <span> Ready To Upload</span>
        // },
        {
            id: 'inactive',
            content: <span> {t('Inactive')}</span>
        },
        {
            id: 'Incomplete',
            content: <span> {t("Incomplete")}</span>
        },
        {
            id: 'active',
            content: <span>  {t("Active")}</span>
        },
        {
            id: 'Error',
            content: <div className='custom-error-badge'>
                <span> {t("Error")} </span>
            </div>
        }
    ]
    //function handle the Tab event
    const handleTabChange = useCallback((selectedTabIndex: number) => {
        props.di.globalState.removeLocalStorage('pagination');
        props.di.globalState.removeLocalStorage('inputpage');
        let TempFilter = { ...allFiltersNew };
        props?.loading(true);
        if (TempFilter['Product Status']['change'] && TempFilter['Activity']['change']) {
            setSelected(0)
        }
        switch (selectedTabIndex) {
            case 0:
                TempFilter['Product Status']['change'] = false
                TempFilter['Product Status']['textValue'] = ""
                TempFilter['Activity']['change'] = false
                TempFilter['Activity']['textValue'] = ""
                TempFilter['Product Status']['value'] = "items.status"
                setallFilters(TempFilter)
                props.di.globalState.set(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, JSON.stringify(TempFilter), true)
                break;
            case 1:
                TempFilter['Product Status']['change'] = true
                TempFilter['Product Status']['textValue'] = "Not Listed"
                TempFilter['Activity']['change'] = false
                TempFilter['Activity']['textValue'] = ""
                TempFilter['Product Status']['value'] = "cif_amazon_multi_inactive"
                setallFilters(TempFilter)
                isOpen && selected !== 1 && setTourLoading(true)
                props.di.globalState.set(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, JSON.stringify(TempFilter), true)
                break;
            case 2:
                TempFilter['Product Status']['change'] = true
                TempFilter['Product Status']['textValue'] = "Inactive"
                TempFilter['Activity']['change'] = false
                TempFilter['Activity']['textValue'] = ""
                TempFilter['Product Status']['value'] = "items.status"
                setallFilters(TempFilter)
                props.di.globalState.set(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, JSON.stringify(TempFilter), true)
                break;
            // case 2:
            //     TempFilter['Product Status']['change'] = true
            //     TempFilter['Product Status']['textValue'] = "Ready To Upload"
            //     TempFilter['Activity']['change'] = false
            //     TempFilter['Activity']['textValue'] = ""
            //     TempFilter['Product Status']['value'] = "items.status"
            //     setallFilters(TempFilter)
            //     props.di.globalState.set(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, JSON.stringify(TempFilter), true)
            //     break;
            case 4:
                TempFilter['Product Status']['change'] = true
                TempFilter['Product Status']['textValue'] = "Active"
                TempFilter['Activity']['change'] = false
                TempFilter['Activity']['textValue'] = ""
                TempFilter['Product Status']['value'] = "items.status"
                setallFilters(TempFilter)
                props.di.globalState.set(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, JSON.stringify(TempFilter), true)
                break;
            case 3:
                TempFilter['Product Status']['change'] = true
                TempFilter['Product Status']['textValue'] = "Incomplete"
                TempFilter['Activity']['change'] = false
                TempFilter['Activity']['textValue'] = ""
                TempFilter['Product Status']['value'] = "items.status"
                setallFilters(TempFilter)
                props.di.globalState.set(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, JSON.stringify(TempFilter), true)
                break;
            case 5:
                TempFilter['Activity']['change'] = true
                TempFilter['Activity']['textValue'] = "error"
                TempFilter['Product Status']['change'] = false
                TempFilter['Product Status']['textValue'] = ""
                setallFilters(TempFilter)
                props.di.globalState.set(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, JSON.stringify(TempFilter), true)
                break;
        }
    }, [selected]);

    // this useEffect gets the data from session storage
    useEffect(() => {
        if (props.di.globalState.get(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, true)) {
            let temp: any = JSON.parse(props.di.globalState.get(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, true) ?? "{}")
            if (temp?.['Product Status']['change'] && temp?.['Activity']['change']) {
                setSelected(0)
            }
            else if (!temp?.['Product Status']['change'] && !temp?.['Activity']['change']) {
                setSelected(0)
            }
            else if (temp?.['Product Status']['change']) {
                switch (temp?.['Product Status']['textValue']) {
                    // case "Ready To Upload":
                    //     setSelected(2)
                    //     break;
                    case "Inactive":
                        setSelected(2)
                        break;
                    case "Active":
                        setSelected(4)
                        break;
                    case "Not Listed":
                        setSelected(1)
                        break;
                    case "Incomplete":
                        setSelected(3)
                        break;
                    case "error":
                        setSelected(5)
                        break;
                    default:
                        setSelected(0)
                        break;
                }
            } else if (temp?.['Activity']['change'] && temp?.['Activity']?.['textValue'] == 'error') {
                setSelected(5)
            }
            else {
                setSelected(0)
            }
        } else {
            setSelected(0)
        }
    }, [props.di.globalState.get(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`, true)])

    return (
        <>
            {/* <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange} fitted /> */}
            <CustomTabs tabs={tabs} onSelect={handleTabChange} selected={selected} />
        </>
    )
}

export default memo(TabsComponent);